var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route.meta.breadcrumb || _vm.$route.meta.pageTitle)?_c('b-row',{staticClass:"content-header"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }